import React from 'react';
import _ from 'lodash';
import toast from 'react-hot-toast';
import { Box, Button, FormControl, InputLabel, MenuItem, Select, Stack, Typography } from '@mui/material';
import { useMutation } from 'react-fetching-library';
import { submitAccomodationDiagramAction, deleteAccomodationDiagramAction, cloneAccomodationDiagramAction, changeAccommodationOwnershipAction } from '../../../services/request';
import { useAccomodationDiagram } from './AccomodationDiagramContext';
import { ConfirmDialog } from '../../../components/ConfirmDialog';
import { OwnershipDialog } from './dialog/OwnershipDialog';
import { useApp } from '../../../AppContext';

export const AccomodationDiagramChoice = ({ setSelectedAccomodationDiagramProps,
  resorts, camps, existingAccomodations, setExistingAccomodations, allExistingAccomodations, setAllExistingAccomodations }) => {
  const { loading: mutationLoading, mutate } = useMutation(submitAccomodationDiagramAction);
  const { mutate: deleteMutate } = useMutation(deleteAccomodationDiagramAction);
  const { mutate: cloneMutate } = useMutation(cloneAccomodationDiagramAction);
  const { mutate: changeOwnershipMutate } = useMutation(changeAccommodationOwnershipAction);
  const { setSelectedAccomodationDiagram, showOwnershipDialog, setShowOwnershipDialog, setSavingDisabled } = useAccomodationDiagram();
  const { ownershipHash } = useApp();
  const [selectedResort, setSelectedResort] = React.useState(null);
  const [selectedCamp, setSelectedCamp] = React.useState(null);
  const [accomodationExists, setAccomodationExists] = React.useState(null);
  const [accomodationChecking, setAccomodationChecking] = React.useState(true);
  const [openDeleteDialog, setOpenDeleteDialog] = React.useState(false);
  const [selectedDiagramToClone, setSelectedDiagramToClone] = React.useState(null);

  const handleChangeCamp = val => {
    setAccomodationChecking(true);
    const checkForExistingAccomodation = existingAccomodations.filter(ea => ea.resort == selectedResort && ea.camp == val);
    if (checkForExistingAccomodation.length > 0) {
      setAccomodationExists(checkForExistingAccomodation[0]);
    } else {
      setAccomodationExists(null);
    }
    setSelectedCamp(val);
    setAccomodationChecking(false);
  };

  const handleSubmit = async() => {
    if (accomodationExists) {
      const { error, payload, status } = await changeOwnershipMutate({ ownershipHash, verify: true }, accomodationExists.id);
      if (!error) {
        setSelectedAccomodationDiagram(payload);
        setSelectedAccomodationDiagramProps(payload);
      } else if (status == 428) {
        setShowOwnershipDialog(true);
        setSavingDisabled(true);
      }

    } else {
      // Tworzymy nowy diagram
      const data = {
        'resort': selectedResort,
        'camp': selectedCamp,
        ownershipHash
      };
      const { error, payload } = await mutate(data, 'POST');
      if (!error) {
        setSelectedAccomodationDiagram(payload);
        setSelectedAccomodationDiagramProps(payload);
        setExistingAccomodations(prev => [...prev, payload]);
        setAllExistingAccomodations(prev => [...prev, payload]);
        toast.success('Pomyślnie utworzono nowy diagram');
      } else {
        toast.error('Nie udało się utworzyć nowego diagramu');
      }
    };
  };

  const handleDelete = async () => {
    const { error, payload } = await deleteMutate(accomodationExists.id);
    if (!error) {
      toast.success('Pomyślnie usunięto diagram');
      setExistingAccomodations(prevAccs => prevAccs.filter(ad => ad.id != accomodationExists.id));
      setAccomodationExists(null);
    } else {
      toast.error(payload);
    }
  };

  const handleClone = async() => {
    const data = {
      'resort': selectedResort,
      'camp': selectedCamp
    };
    const { error, payload } = await cloneMutate(data, selectedDiagramToClone);
    if (!error) {
      setSelectedAccomodationDiagram(payload);
      setSelectedAccomodationDiagramProps(payload);
      setExistingAccomodations(prev => [...prev, payload]);
      setAllExistingAccomodations(prev => [...prev, payload]);
      toast.success('Pomyślnie utworzono nowy diagram');
    } else {
      toast.error('Nie udało się utworzyć nowego diagramu');
    }
  };

  const takeControlCallback = async shouldTakeControl => {
    if (shouldTakeControl) {
      const { error, payload } = await changeOwnershipMutate({ ownershipHash, verify: false }, accomodationExists.id);
      if (!error) {
        setSelectedAccomodationDiagram(payload);
        setSelectedAccomodationDiagramProps(payload);
        setShowOwnershipDialog(false);
        setSavingDisabled(false);
      }
    } else {
      const { error, payload } = await changeOwnershipMutate({ onlyData: true }, accomodationExists.id);
      if (!error) {
        setShowOwnershipDialog(false);
        setSavingDisabled(true);
        setSelectedAccomodationDiagram(payload);
        setSelectedAccomodationDiagramProps(payload);
      }
    }
  };

  return (
    <Stack>
      <FormControl sx={{ marginBottom: 2 }}>
        <InputLabel>Ośrodek</InputLabel>
        <Select
          value={selectedResort}
          label="ośrodki"
          onChange={e => setSelectedResort(e.target.value)}
        >
          {!_.isEmpty(resorts)
            ? _.map(resorts, (obj, idx) => (
              <MenuItem value={obj.id} key={idx} style={{ whiteSpace: 'normal' }}>
                {obj.name}
              </MenuItem>
            ))
            : []}
        </Select>
      </FormControl>

      <FormControl sx={{ marginBottom: 2 }}>
        <InputLabel>Turnus</InputLabel>
        <Select
          value={selectedCamp}
          label="turnus"
          onChange={e => handleChangeCamp(e.target.value)}
        >
          { selectedResort &&
          !_.isEmpty(camps) &&
           _.map(camps, (obj, idx) => (
             <MenuItem value={obj.id} key={idx} style={{ whiteSpace: 'normal' }}>
               {obj.name}
             </MenuItem>
           ))
          }
        </Select>
      </FormControl>
      { accomodationExists &&
        <Button disabled={accomodationChecking || mutationLoading} variant="contained" onClick={handleSubmit} fullWidth>
          Pokaż
        </Button>
      }
      { !accomodationExists && selectedCamp && selectedResort && <Stack direction="row" alignItems="center" mt={3} spacing={3}>
        <Stack direction="column">
          <FormControl sx={{ marginBottom: 2, width: '100vh' }}>
            <InputLabel>Wybierz istniejący diagram</InputLabel>
            <Select
              value={selectedDiagramToClone}
              label="klonuj diagram"
              onChange={e => setSelectedDiagramToClone(e.target.value)}
            >
              { !_.isEmpty(allExistingAccomodations) &&
           allExistingAccomodations.filter(obj => obj.resort == selectedResort).map((obj, idx) => (
             <MenuItem value={obj.id} key={idx} style={{ whiteSpace: 'normal' }}>
               {obj.name}
             </MenuItem>
           ))
              }
            </Select>
          </FormControl>

          <Button variant="contained" fullWidth onClick={handleClone}>Klonuj</Button>
        </Stack>
        <Typography variant="h6">lub</Typography>
        <Button disabled={accomodationChecking || mutationLoading} variant="contained" onClick={handleSubmit} fullWidth>
          Generuj
        </Button>
      </Stack>}
      <Box height={250} />
      <Stack width="10px">
        {accomodationExists ? <Button variant="contained" color="error" width="10px" onClick={() => setOpenDeleteDialog(true)}>Usuń</Button> : null}
      </Stack>
      <ConfirmDialog
        title="Usunąć aplikacje?"
        open={openDeleteDialog}
        setOpen={setOpenDeleteDialog}
        onConfirm={handleDelete}
      >
        Czy na pewno chcesz usunąć ten diagram?
      </ConfirmDialog>
      {showOwnershipDialog && <OwnershipDialog open={showOwnershipDialog} setOpen={setShowOwnershipDialog} takeControlCallback={takeControlCallback} />}
    </Stack>
  );
};
